/*
 * Copyright (c) 2023 Bluemate B.V.
 */
import './style/usersFilter.scss';

import {ChangeKeyFunction, CloseButton, WithBackground} from '@dvrd/dvr-controls';

import React, {KeyboardEventHandler, MouseEventHandler} from 'react';
import {useTranslation} from 'react-i18next';

import {NullString, UserFilter} from '../../../../util/interfaces';

import {BluemateButton, BluemateInput} from '../../../controls';

interface Props {
    onChangeFilter: ChangeKeyFunction<string>;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onClose: MouseEventHandler;
    filter: UserFilter;
    active: boolean;
}

export default function UsersFilter(props: Props) {
    const {t} = useTranslation();
    const {filter, onChangeFilter, onClose, onSubmit, active} = props;

    function renderBody() {
        return (
            <div className='body-container'>
                {renderText(t('admin.users.filter.userId', 'User ID'), filter.user_id, 'user_id')}
                {renderText(t('admin.users.filter.accountId', 'Account ID'), filter.account_id, 'account_id')}
                {renderText(t('admin.users.filter.customerId', 'Customer ID'), filter.customer_id, 'customer_id')}
                {renderText(t('admin.users.filter.firstname', 'Voornaam'), filter.firstname, 'firstname', true)}
                {renderText(t('admin.users.filter.lastname', 'Achternaam'), filter.lastname, 'lastname')}
                {renderText(t('admin.users.filter.companyName', 'Bedrijfsnaam'), filter.company_name, 'company_name')}
                {renderText(t('admin.users.filter.email', 'E-mailadres'), filter.email, 'email')}
            </div>
        );
    }

    function renderText(label: string, value: NullString, key: keyof UserFilter, autoFocus: boolean = false) {
        return (
            <BluemateInput
                onChange={onChangeFilter(key)}
                value={value ?? ''}
                label={label}
                onEnter={onSubmit}
                autoFocus={autoFocus}
            />
        );
    }

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='users-filter default-popup'>
                <div className='header-container'>
                    <label className='header-title'>{t('admin.users.filter.title', 'Filter klanten')}</label>
                    <CloseButton onClick={onClose} />
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <BluemateButton onClick={onClose} label={t('admin.users.filter.cancel', 'Annuleren')} secondary />
                    <BluemateButton onClick={onSubmit} label={t('admin.users.filter.apply', 'Toepassen')} />
                </div>
            </div>
        </WithBackground>
    );
}
